import "./src/styles/resets.scss";

export const onServiceWorkerUpdateReady = () => globalThis.location.reload();
